import { render, staticRenderFns } from "./owner-activity.vue?vue&type=template&id=02cc8853&scoped=true&"
import script from "./owner-activity.vue?vue&type=script&lang=js&"
export * from "./owner-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cc8853",
  null
  
)

export default component.exports